export type BusinessServicesConfiguration = {
  getToken: () => string | undefined;
};
class BusinessServicesConfig {
  private configuration: BusinessServicesConfiguration | null = null;

  configure(configuration: BusinessServicesConfiguration): void {
    this.configuration = configuration;
  }

  getConfiguration(): BusinessServicesConfiguration {
    /**
     * Currently in tests we export methods like
     * import { getRooms, getUser } from '../../services';
     * that are bound to internal configuration.
     */
    if (process.env.NODE_ENV === 'test') {
      return { getToken: () => undefined };
    }

    if (this.configuration === null) {
      throw new Error('BusinessServicesConfiguration is not configured');
    } else {
      return this.configuration;
    }
  }

  updateTokenGetter(getToken: () => string | undefined): void {
    if (this.configuration) {
      this.configuration = {
        ...this.configuration,
        getToken,
      };
    } else {
      throw new Error('BusinessServicesConfiguration is not configured');
    }
  }
}

export const businessServicesConfig = new BusinessServicesConfig();
